// @flow

import React from 'react';
import styles from './cellView.scss';
import selectedRackCell from '../../../assets/images/selected-checked.svg';
import unselectedRackCell from '../../../assets/images/ic_check_box_outline_blank_black_24px.svg';

type Props = {
  prefix?: string,
  selectedCells: Object,
  availableCells: Array<any>,
  cellUlClassName: string,
  cellListClassName: string,
  cellListBlockedClassName: string,
  addEditCellPrefixModal: boolean,
  handleSetIsRackCell: Function
};

const CellsList = ({
  prefix,
  selectedCells,
  availableCells,
  cellUlClassName,
  cellListClassName,
  cellListBlockedClassName,
  addEditCellPrefixModal,
  handleSetIsRackCell
}: Props) => (
  <ul
    className={`${cellUlClassName} ${
      addEditCellPrefixModal ? styles.addEditCellPrefixModal : null
    }`}
  >
    {availableCells.map(cell =>
      prefix === '' || cell.prefix === prefix ? (
        addEditCellPrefixModal ? (
          <div key={cell.name} className={styles.cellContainer}>
            <li
              className={
                selectedCells[cell.name]
                  ? `${cellListClassName} ${cellListBlockedClassName}`
                  : `${cellListClassName}`
              }
              name={cell.name}
            >
              {cell.name}
            </li>
            <li
              className={styles.rackCellCheckbox}
              name={cell.name}
              onClick={
                selectedCells[cell.name]
                  ? e => handleSetIsRackCell({ ...e, cell })
                  : null
              }
            >
              <img
                className={
                  cell.isRack
                    ? styles.cellCheckBoxChecked
                    : styles.cellCheckBoxUnchecked
                }
                src={cell.isRack ? selectedRackCell : unselectedRackCell}
                alt=""
                style={
                  selectedCells[cell.name]
                    ? {}
                    : { cursor: 'not-allowed', opacity: '0.3' }
                }
              />
            </li>
          </div>
        ) : (
          <li
            className={
              selectedCells[cell.name]
                ? `${cellListClassName} ${cellListBlockedClassName}`
                : `${cellListClassName}`
            }
            key={cell.name}
            name={cell.name}
          >
            {cell.name}
          </li>
        )
      ) : null
    )}
  </ul>
);

CellsList.defaultProps = {
  prefix: ''
};
export default CellsList;
